/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists, mapValues} from '../runtime'
/**
 *
 * @export
 * @interface MessageDTO
 */
export interface MessageDTO {
    /**
     *
     * @type {string}
     * @memberof MessageDTO
     */
    phone: string
    /**
     *
     * @type {string}
     * @memberof MessageDTO
     */
    message: string
    /**
     *
     * @type {string}
     * @memberof MessageDTO
     */
    region?: MessageDTORegionEnum
}

export function MessageDTOFromJSON(json: any): MessageDTO {
    return MessageDTOFromJSONTyped(json, false)
}

export function MessageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageDTO {
    if (json === undefined || json === null) {
        return json
    }
    return {
        phone: json['phone'],
        message: json['message'],
        region: !exists(json, 'region') ? undefined : json['region'],
    }
}

export function MessageDTOToJSON(value?: MessageDTO | null): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        phone: value.phone,
        message: value.message,
        region: value.region,
    }
}

/**
 * @export
 * @enum {string}
 */
export enum MessageDTORegionEnum {
    RU = 'RU',
    BY = 'BY',
    KZ = 'KZ',
    UA = 'UA',
}
